import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Download, ArrowRight } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-24 relative overflow-hidden bg-[#1e1b4b]" data-id="element-180">
      {/* Radial Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-purple-900/40 via-[#1e1b4b] to-[#1e1b4b]" data-id="element-181" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-183">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-184">
            Tu Transformación Profesional <br data-id="element-185" />
            <span className="text-[#d4af37]" data-id="element-186">Comienza Hoy</span>
          </h2>

          <p className="text-xl text-purple-200 mb-10 font-light max-w-2xl mx-auto" data-id="element-187">
            No postergues más tu desarrollo. El Sistema Profesional de Reiki
            está listo para guiarte paso a paso hacia una práctica estructurada,
            confiada y profesional.
          </p>

          <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full px-6 py-2 mb-10" data-id="element-188">
            <span className="text-[#d4af37] font-semibold text-sm flex items-center gap-2" data-id="element-189">
              <span className="animate-pulse" data-id="element-190">⚡</span> Precio de lanzamiento
              disponible por tiempo limitado
            </span>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-191">
            <a href="https://checkout2.rosetadigital.com/cart/47082293100722:1" target="_blank" rel="noopener noreferrer" className="px-10 py-5 bg-[#d4af37] hover:bg-[#f0c040] text-[#0f0a2e] font-bold text-xl rounded shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:shadow-[0_0_50px_rgba(212,175,55,0.6)] transition-all transform hover:scale-105 flex items-center gap-3" data-id="element-192">
              ACCEDER AL SISTEMA AHORA <ArrowRight className="w-6 h-6" data-id="element-193" />
            </a>

            <a href="#pricing" className="text-purple-300 hover:text-white underline underline-offset-4 transition-colors" data-id="element-194">
              Ver comparación de combos ↑
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-8 mt-16 text-sm text-purple-300" data-id="element-195">
            <div className="flex items-center gap-2" data-id="element-196">
              <Lock className="w-4 h-4" data-id="element-197" /> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-198">
              <ShieldCheck className="w-4 h-4" data-id="element-199" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-2" data-id="element-200">
              <Download className="w-4 h-4" data-id="element-201" /> Acceso Inmediato
            </div>
          </div>
        </motion.div>

        <div className="mt-24 pt-8 border-t border-white/10 text-purple-400 text-sm" data-id="element-202">
          <p data-id="element-203">
            © 2025 Sistema Profesional de Reiki. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}